export default __webpack_public_path__ + "static/media/javascript.090ba3de.svg";